import React from 'react'
import { Helpers } from '../../../helpers/Helpers'
import { GetDeviceDataListForMapResponseItem } from '../../../models/response/deviceData/GetDeviceDataListForMapResponse'
import moment from 'moment';
import { GetLastEventsResponseItem } from '../../../models/response/event/GetLastEventsResponse';
import Box from '../../../components/Box';
import Dot from '../../../components/Dot';
import { VehicleDetailHistoryModel } from '../Map';
import { DeviceConnectionTypeEnum, LastEventEventTypeEnum } from '../../../models/common/Enums';

interface Props {
    focusedDeviceId: string | null | undefined
    data: GetDeviceDataListForMapResponseItem | undefined
    resetFocusedDevice: () => void
    isShown: boolean
    setVehicleDetailHistory: React.Dispatch<React.SetStateAction<VehicleDetailHistoryModel | undefined>>
    lastEvents: GetLastEventsResponseItem[]
    activeDetailTab: number
    setActiveDetailTab: React.Dispatch<React.SetStateAction<number>>
    lastEventsTake: number
    setLastEventsTake: React.Dispatch<React.SetStateAction<number>>
    getLastEvents: (_take: number) => Promise<void>
}

const VehicleDetail = ({ getLastEvents, lastEventsTake, setLastEventsTake, focusedDeviceId, data, resetFocusedDevice, isShown, setVehicleDetailHistory, lastEvents, activeDetailTab, setActiveDetailTab }: Props) => {
    const getColor = (perc: number) => {
        var r, g, b = 0;
        if (perc < 50) {
            r = 255;
            g = Math.round(5.1 * perc);
        }
        else {
            g = 255;
            r = Math.round(510 - 5.10 * perc);
        }
        var h = r * 0x10000 + g * 0x100 + b * 0x1;
        return '#' + ('000000' + h.toString(16)).slice(-6);
    }

    return (
        <React.Fragment>
            {
                (isShown && focusedDeviceId && data) && (
                    <div style={{ overflow: 'hidden', width: '20%', position: 'absolute', right: '15px', height: 'calc(100% - 30px)', top: '15px' }} className="menu menu-sub menu-sub-dropdown show">
                        <Box>
                            <div className="p-3">
                                <div className="d-flex">
                                    <div className="d-flex align-items-center">
                                        {/* <div style={{ width: 16, height: 16, background: data?.statusColor, borderRadius: 99 }}>&nbsp;</div> */}
                                        <img style={{ width: 24, height: 24 }} src={Helpers.getEndpoint() + (`/markers/arrow-${data?.statusColor}-${data?.directionDegree}.png`)} />
                                    </div>
                                    <Box ml='5px' flexGrow={1} flexDirection='row'>
                                        <Box justifyContent='center'>
                                            <h5 style={{ lineHeight: 'normal' }} className="m-0">{data?.plate}</h5>
                                        </Box>
                                        <Box ml='5px' justifyContent='center'>
                                            <span className='m-0' style={{ fontSize: 12, color: data?.statusColor, lineHeight: 'normal' }}>({Helpers.getStatusText(data?.status)})</span>
                                        </Box>
                                    </Box>

                                    {
                                        !Helpers.isEmpty(data.signalPower) && (
                                            <Box mr='5px' justifyContent='center' flexDirection='row' alignItems='flex-end'>
                                                <Box mr={'3px'} height='20%' width='4px' borderRadius='999px' bg={(data.signalPower ? data.signalPower : 0) >= 1 ? 'green' : '#c6cfe8'}>&nbsp;</Box>
                                                <Box mr={'3px'} height='40%' width='4px' borderRadius='999px' bg={(data.signalPower ? data.signalPower : 0) >= 2 ? 'green' : '#c6cfe8'}>&nbsp;</Box>
                                                <Box mr={'3px'} height='60%' width='4px' borderRadius='999px' bg={(data.signalPower ? data.signalPower : 0) >= 3 ? 'green' : '#c6cfe8'}>&nbsp;</Box>
                                                <Box mr={'3px'} height='80%' width='4px' borderRadius='999px' bg={(data.signalPower ? data.signalPower : 0) >= 4 ? 'green' : '#c6cfe8'}>&nbsp;</Box>
                                                <Box height='100%' width='4px' borderRadius='999px' bg={(data.signalPower ? data.signalPower : 0) >= 5 ? 'green' : '#c6cfe8'}>&nbsp;</Box>
                                            </Box>
                                        )
                                    }

                                    {
                                        !Helpers.isEmpty(data.batteryPercentage) && (
                                            <Box mr='5px' justifyContent='center'>
                                                <Box p='2px' height='16px' borderRadius='3px' border={'1px solid ' + getColor((data.batteryPercentage ? data.batteryPercentage : 0))} width='32px' justifyContent='center'>
                                                    <Box borderRadius='2px' bg={getColor((data.batteryPercentage ? data.batteryPercentage : 0))} height='100%' width={data.batteryPercentage + '%'}><React.Fragment></React.Fragment></Box>
                                                </Box>
                                            </Box>
                                        )
                                    }

                                    <div className="d-flex">
                                        <i onClick={resetFocusedDevice} style={{ fontSize: 24 }} className="actionIcon fa fa-times" />
                                    </div>
                                </div>
                            </div>
                            <hr className="m-0" />
                        </Box>
                        <Box flexGrow={1} overflowY='auto'>
                            <Box className="p-5">
                                {
                                    activeDetailTab == 1 && (
                                        <React.Fragment>
                                            <Box flexDirection='row' gap='1.25rem'>
                                                <Box flex={1}>
                                                    <Box>
                                                        <h5>Anlık Hız</h5>
                                                        <span>{data?.kmPerHour} KM/S</span>
                                                    </Box>
                                                </Box>
                                                <Box flex={1}>
                                                    <h5>Aktif Sürücü</h5>
                                                    <span className="d-block">{Helpers.isEmpty(data?.cardDriverNameSurname) ? '-' : data?.cardDriverNameSurname}</span>
                                                    <span className="d-block">{data?.cardDriverRfidDate}</span>
                                                    {/* <span className="d-block">{data?.cardDriverRfid}</span> */}
                                                </Box>
                                            </Box>

                                            <Box flexDirection='row' gap='1.25rem' className='mt-5'>
                                                <Box flex={1}>
                                                    <h5>Günlük Km</h5>
                                                    <span>{data?.totalKmDaily.toFixed(0)} KM</span>
                                                </Box>
                                                <Box flex={1}>
                                                    <h5>Sabit Sürücü</h5>
                                                    <span className="d-block">{Helpers.isEmpty(data?.constantDriverNameSurname) ? '-' : data?.constantDriverNameSurname}</span>
                                                    {/* <span className="d-block">{data?.constantDriverRfidDate}</span> */}
                                                    {/* <span className="d-block">{data?.constantDriverRfid}</span> */}
                                                </Box>
                                            </Box>

                                            <Box flexDirection='row' gap='1.25rem' className='mt-5'>
                                                <Box flex={1}>
                                                    <h5>Son Veri</h5>
                                                    <span className='d-block'>C - {data?.gpsDateTimeStr == '0 dk' ? 'Birkaç sn önce' : data?.gpsDateTimeStr + ' önce'}</span>
                                                    <span className='d-block'>S - {data?.createdDateStr == '0 dk' ? 'Birkaç sn önce' : data?.createdDateStr + ' önce'}</span>
                                                </Box>

                                                {
                                                    (!Helpers.isEmpty(data.currentKm) && data?.deviceConnectionTypes?.find(x => x.connectionTypeKey == DeviceConnectionTypeEnum.KLASIK_BAGLANTI)) && (
                                                        <Box flex={1}>
                                                            <h5>Gerçek KM</h5>
                                                            <span>{Helpers.correctPrice(data?.currentKm?.toFixed(0), 0)}</span>
                                                        </Box>
                                                    )
                                                }
                                            </Box>

                                            <Box flexDirection='row' gap='1.25rem' className='mt-5'>
                                                <Box flex={1}>
                                                    <h5>Konum</h5>
                                                    <span>{data?.location}</span>
                                                </Box>
                                            </Box>

                                        </React.Fragment>
                                    )
                                }

                                {
                                    activeDetailTab == 2 && (
                                        <React.Fragment>
                                            <Box flexDirection='row' flexWrap='wrap' gap='1.25rem'>
                                                {
                                                    !Helpers.isEmpty(data.currentKm) && (
                                                        <Box flex={'calc(50% - 1.25rem)'}>
                                                            <h5 >Gerçek KM</h5>
                                                            <span>{Helpers.correctPrice(data?.currentKm?.toFixed(0), 0)}</span>
                                                        </Box>
                                                    )
                                                }

                                                {
                                                    !Helpers.isEmpty(data.dailySpentFuel) && (
                                                        <Box flex={'calc(50% - 1.25rem)'}>
                                                            <h5>24s Yakıt Tüketimi</h5>
                                                            <span>{data?.dailySpentFuel} LT</span>
                                                        </Box>
                                                    )
                                                }

                                                {
                                                    !Helpers.isEmpty(data.motorRev) && (
                                                        <Box flex={'calc(50% - 1.25rem)'}>
                                                            <h5 >Motor Devri</h5>
                                                            <span>{data?.motorRev} RPM</span>
                                                        </Box>
                                                    )
                                                }

                                                {
                                                    !Helpers.isEmpty(data.currentFuel) && (
                                                        <Box flex={'calc(50% - 1.25rem)'}>
                                                            <h5 >Depodaki Yakıt Miktarı</h5>
                                                            <span>{data?.currentFuel} LT</span>
                                                        </Box>
                                                    )
                                                }

                                                {
                                                    !Helpers.isEmpty(data.engineHeat) && (
                                                        <Box flex={'calc(50% - 1.25rem)'}>
                                                            <h5>Motor Sıcaklığı</h5>
                                                            <span>{data?.engineHeat} °C</span>
                                                        </Box>
                                                    )
                                                }

                                                {/* {
                                                    !Helpers.isEmpty(data.pedalPercentage) && (
                                                        <Box flex={'calc(50% - 1.25rem)'}>
                                                            <h5 >Gaz Pedalı Konumu</h5>
                                                            <span>%{data?.pedalPercentage}</span>
                                                        </Box>
                                                    )
                                                } */}

                                                {
                                                    !Helpers.isEmpty(data.adBlue) && (
                                                        <Box flex={'calc(50% - 1.25rem)'}>
                                                            <h5>AdBlue Seviyesi</h5>
                                                            <span>%{data?.adBlue}</span>
                                                        </Box>
                                                    )
                                                }

                                                {
                                                    !Helpers.isEmpty(data.dailyRunningMinutes) && (
                                                        <Box flex={'calc(50% - 1.25rem)'}>
                                                            <h5>Günlük Çalışma Süresi</h5>
                                                            <span>{data?.dailyRunningMinutes} dk</span>
                                                        </Box>
                                                    )
                                                }
                                            </Box>
                                        </React.Fragment>
                                    )
                                }

                                {
                                    activeDetailTab == 3 && (
                                        <React.Fragment>
                                            <Box flexDirection='row' flexWrap='wrap' gap='1.25rem'>
                                                {
                                                    (true || !Helpers.isEmpty(data?.tacoDailyTotalDrivingTimeStr)) && (
                                                        <Box flex={'calc(50% - 1.25rem)'}>
                                                            <h5>Toplam Sürüş Süresi</h5>
                                                            <span>{data?.tacoDailyTotalDrivingTimeStr}</span>
                                                        </Box>
                                                    )
                                                }

                                                {
                                                    (true || !Helpers.isEmpty(data?.tacoActiveRemainingDrivingTimeStr)) && (
                                                        <Box flex={'calc(50% - 1.25rem)'}>
                                                            <h5>Aktif Kalan Sürüş Süresi</h5>
                                                            <span>{data?.tacoActiveRemainingDrivingTimeStr}</span>
                                                        </Box>
                                                    )
                                                }

                                                {
                                                    (true || !Helpers.isEmpty(data?.tacoUninterruptedDrivingTimeStr)) && (
                                                        <Box flex={'calc(50% - 1.25rem)'}>
                                                            <h5>Kesintisiz Sürüş Süresi</h5>
                                                            <span>{data?.tacoUninterruptedDrivingTimeStr}</span>
                                                        </Box>
                                                    )
                                                }

                                                {
                                                    (true || !Helpers.isEmpty(data?.taco24HoursOfRemainingDrivingTimeStr)) && (
                                                        <Box flex={'calc(50% - 1.25rem)'}>
                                                            <h5>24s Kalan Sürüş Süresi</h5>
                                                            <span>{data?.taco24HoursOfRemainingDrivingTimeStr}</span>
                                                        </Box>
                                                    )
                                                }

                                                {
                                                    (true || !Helpers.isEmpty(data?.tacoWeeklyDrivingTimeStr)) && (
                                                        <Box flex={'calc(50% - 1.25rem)'}>
                                                            <h5>Haftalık Sürüş Süresi</h5>
                                                            <span>{data?.tacoWeeklyDrivingTimeStr}</span>
                                                        </Box>
                                                    )
                                                }

                                                {
                                                    (true || !Helpers.isEmpty(data?.tacoWeeklyRemainingDrivingTimeStr)) && (
                                                        <Box flex={'calc(50% - 1.25rem)'}>
                                                            <h5>Haftalık Kalan Sürüş Süresi</h5>
                                                            <span>{data?.tacoWeeklyRemainingDrivingTimeStr}</span>
                                                        </Box>
                                                    )
                                                }

                                                {
                                                    (true || !Helpers.isEmpty(data?.tacoTwoWeeklyDrivingTimeStr)) && (
                                                        <Box flex={'calc(50% - 1.25rem)'}>
                                                            <h5>2 Haftalık Sürüş Süresi</h5>
                                                            <span>{data?.tacoTwoWeeklyDrivingTimeStr}</span>
                                                        </Box>
                                                    )
                                                }

                                                {
                                                    (true || !Helpers.isEmpty(data?.tacoTwoWeeklyRemainingDrivingTimeStr)) && (
                                                        <Box flex={'calc(50% - 1.25rem)'}>
                                                            <h5>2 Haftalık Kalan Sürüş Süresi</h5>
                                                            <span>{data?.tacoTwoWeeklyRemainingDrivingTimeStr}</span>
                                                        </Box>
                                                    )
                                                }

                                                {
                                                    (true || !Helpers.isEmpty(data?.tacoRestTimeStr)) && (
                                                        <Box flex={'calc(50% - 1.25rem)'}>
                                                            <h5>Mola Süresi</h5>
                                                            <span>{data?.tacoRestTimeStr}</span>
                                                        </Box>
                                                    )
                                                }

                                                {
                                                    (true || !Helpers.isEmpty(data?.tacoActiveBreakRemainingTimeStr)) && (
                                                        <Box flex={'calc(50% - 1.25rem)'}>
                                                            <h5>Aktif Moladan Kalan Süre</h5>
                                                            <span>{data?.tacoActiveBreakRemainingTimeStr}</span>
                                                        </Box>
                                                    )
                                                }

                                                {/* {
                                                    (true || !Helpers.isEmpty(data?.tacoOtherWorksDurationStr)) && (
                                                        <Box flex={'calc(50% - 1.25rem)'}>
                                                            <h5>Diğer İşler Süresi</h5>
                                                            <span>{data?.tacoOtherWorksDurationStr}</span>
                                                        </Box>
                                                    )
                                                } */}



                                                {/* {
                                                    (true || !Helpers.isEmpty(data?.tacoTimeRemainingUntilBreakStr)) && (
                                                        <Box flex={'calc(50% - 1.25rem)'}>
                                                            <h5>Molaya Kalan Süre</h5>
                                                            <span>{data?.tacoTimeRemainingUntilBreakStr}</span>
                                                        </Box>
                                                    )
                                                } */}
                                            </Box>
                                        </React.Fragment>
                                    )
                                }

                                <React.Fragment>
                                    {
                                        data?.ambars?.map((ambarItem, ambarIndex) =>
                                            <React.Fragment>
                                                {
                                                    activeDetailTab == (3 + (ambarIndex + 1)) && (
                                                        <Box>
                                                            <Box flexDirection='row' flexWrap='wrap' gap='1.25rem'>
                                                                <Box flex={'calc(100% - 1.25rem)'}>
                                                                    <h3 className='text-danger'>Yük {ambarIndex + 1}</h3>
                                                                    <span>{ambarItem.refNo} ({ambarItem.orderStatusName})</span>
                                                                </Box>

                                                                <Box flex={'calc(50% - 1.25rem)'}>
                                                                    <h5>Kap Cinsleri</h5>
                                                                    <span>{ambarItem.ambarProducts.map(x => x.potTypeName).join(', ')}</span>
                                                                </Box>

                                                                <Box flex={'calc(50% - 1.25rem)'}>
                                                                    <h5>T. Hacimsel Ağırlık</h5>
                                                                    <span>{Helpers.sumOfNumbers(ambarItem.ambarProducts.map(x => x.weight ?? 0))}</span>
                                                                </Box>

                                                                <Box flex={'calc(50% - 1.25rem)'}>
                                                                    <h5>Çıkış İl</h5>
                                                                    <span>{ambarItem.deliverCountyName}</span>
                                                                </Box>

                                                                <Box flex={'calc(50% - 1.25rem)'}>
                                                                    <h5>Varış İl</h5>
                                                                    <span>{ambarItem.deliverCountyName}</span>
                                                                </Box>

                                                                <Box flex={'calc(50% - 1.25rem)'}>
                                                                    <h5>Çıkış İlçe</h5>
                                                                    <span>{ambarItem.loadingDistrictName}</span>
                                                                </Box>

                                                                <Box flex={'calc(50% - 1.25rem)'}>
                                                                    <h5>Varış İlçe</h5>
                                                                    <span>{ambarItem.deliverDistrictName}</span>
                                                                </Box>

                                                                <Box flex={'calc(50% - 1.25rem)'}>
                                                                    <h5>Çıkış Semt</h5>
                                                                    <span>{ambarItem.loadingNeighborhoodName}</span>
                                                                </Box>

                                                                <Box flex={'calc(50% - 1.25rem)'}>
                                                                    <h5>Varış Semt</h5>
                                                                    <span>{ambarItem.deliverNeighborhoodName}</span>
                                                                </Box>
                                                            </Box>

                                                            {/*  


                                                        <Box mt='1.25rem' ml='1.25rem'>
                                                            <h5>Çıkış Semt</h5>
                                                            <span>{ambarItem.loadingNeighborhoodName}</span>
                                                        </Box> */}
                                                        </Box>
                                                    )
                                                }
                                            </React.Fragment>
                                        )
                                    }
                                </React.Fragment>

                                <Box className='mt-5' flexDirection='row' justifyContent='center' gap='10px'>
                                    <Dot onClick={() => setActiveDetailTab(1)} active={activeDetailTab == 1} />

                                    {
                                        data?.deviceConnectionTypes?.find(x => x.connectionTypeKey == DeviceConnectionTypeEnum.CANBUS_BAGLANTI) && (
                                            <Dot onClick={() => setActiveDetailTab(2)} active={activeDetailTab == 2} />
                                        )
                                    }

                                    {
                                        data?.deviceConnectionTypes?.find(x => x.connectionTypeKey == DeviceConnectionTypeEnum.FMS_KABLO) && (
                                            <Dot onClick={() => setActiveDetailTab(3)} active={activeDetailTab == 3} />
                                        )
                                    }

                                    {
                                        data?.ambars?.map((item, index) =>
                                            <Dot onClick={() => setActiveDetailTab(3 + (index + 1))} active={activeDetailTab == 3 + (index + 1)} />
                                        )
                                    }
                                </Box>

                                <Box height='1px' width='100%' className='mt-5 mb-5'><hr className="m-0" /></Box>

                                <React.Fragment>
                                    <Box flexDirection='row'>
                                        <Box justifyContent='center' flexGrow={1}>
                                            <h5 className='m-0'>Son Araç Hareketleri</h5>
                                        </Box>
                                        <Box justifyContent='center'>
                                            <select value={lastEventsTake} onChange={(e) => {
                                                setLastEventsTake(parseInt(e.target.value));
                                                getLastEvents(parseInt(e.target.value));
                                            }} className='bg-white' style={{ outline: 'none', padding: '3px', borderRadius: 4, border: '1px solid rgb(241, 241, 244)', boxShadow: '0 0.1rem 1rem 0.25rem rgba(0, 0, 0, 0.05)' }}>
                                                <option value={10}>10 Kayıt</option>
                                                <option value={25}>25 Kayıt</option>
                                                <option value={50}>50 Kayıt</option>
                                                <option value={100}>100 Kayıt</option>
                                            </select>
                                        </Box>
                                    </Box>

                                    <Box>
                                        {
                                            lastEvents.map((item, index) =>
                                                <Box flexDirection='row' className='p-3 bg-white' border='1px solid rgb(241, 241, 244)' borderRadius='4' mt={'10px'} boxShadow='0 0.1rem 1rem 0.25rem rgba(0, 0, 0, 0.05)'>
                                                    <Box width={'22px'} justifyContent='center'>
                                                        {item.eventType == LastEventEventTypeEnum.EVENT && <i style={{ color: '#a9a9a9', fontSize: 22 }} className='text-primary fa fa-bell' />}
                                                        {item.eventType == LastEventEventTypeEnum.WARNING && <i style={{ fontSize: 22 }} className='text-warning fa fa-exclamation-triangle' />}
                                                        {item.eventType == LastEventEventTypeEnum.BREACH && <i style={{ color: '#a9a9a9', fontSize: 22 }} className='text-danger fa fa-times-circle' />}
                                                    </Box>
                                                    <Box ml='10px' flexGrow={1} justifyContent='center'>
                                                        <span style={{ color: 'black' }}>{item.message.split('plakalı araç')[1].trim()}</span>
                                                    </Box>
                                                </Box>
                                            )
                                        }
                                    </Box>
                                </React.Fragment>
                            </Box>
                        </Box>
                        <Box bg='blue' flexDirection='row'>
                            <div
                                onClick={() => setVehicleDetailHistory({
                                    startDate: moment(moment().format('YYYY-MM-DD 00:00:00'), 'YYYY-MM-DD HH:mm:ss').toDate(),
                                    endDate: moment(moment().format('YYYY-MM-DD 23:59:59'), 'YYYY-MM-DD HH:mm:ss').toDate()
                                })}
                                className="actionIcon d-flex bg-primary flex-grow-1 py-3 justify-content-center">
                                <i style={{ fontSize: 18 }} className="text-white fa fa-history" />
                            </div>

                            <div className="actionIcon d-flex bg-warning flex-grow-1 py-3 justify-content-center">
                                <i style={{ fontSize: 18 }} className="text-black fa fa-camera" />
                            </div>

                            <div className="actionIcon d-flex bg-info flex-grow-1 py-3 justify-content-center">
                                <i style={{ fontSize: 18 }} className="text-white fa fa-bars" />
                            </div>
                        </Box>
                    </div >
                )
            }
        </React.Fragment >
    )
}

export default VehicleDetail;